import { render, staticRenderFns } from "./User-register-v3.vue?vue&type=template&id=253f3e7c&"
import script from "./User-register-v3.vue?vue&type=script&lang=js&"
export * from "./User-register-v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports